export interface User {
    publicId: string;
    name: string;
    email: string;
    role: number;
    createdAt: Date;
    updatedAt: Date;
    deletedAt: Date | undefined;
}

export const userRoles = [
    "Guest",
    "User",
    "Admin",
    "Super Admin"
];